import { RefreshContentTaskStatus } from "../widgetRuntime/apis/api.interfaces";
import { tryGetHostApi } from "./externalApi";
/**
 * Try to get feeds from shell cache rather than get it from http request
 */
export async function tryGetFeedsContent() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 1, 1);
    if (shellFeedsApi) {
        return shellFeedsApi.tryGetFeedsContent();
    }
    return "";
}
export async function getPageCompositionServiceCache() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 4, 4);
    if (shellFeedsApi) {
        return shellFeedsApi.getPageCompositionServiceCache();
    }
    return "";
}
/**
 * Try to get the background task status to check whether it's disabled(0)/running(1)/suspended(2)
 */
export async function tryGetBackgroundTaskStatus() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 1, 1);
    if (shellFeedsApi) {
        return shellFeedsApi.tryGetBackgroundTaskStatus();
    }
    return 0;
}
/**
 * Try to invalidate currently using cache.
 */
export async function invalidateFeedsCache() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 1, 1);
    if (shellFeedsApi) {
        return shellFeedsApi.invalidateFeedsCache();
    }
    return 0;
}
/**
 * Try to get rotational preview ids
 */
export async function getRotationalPreviewIds() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 1, 1);
    if (shellFeedsApi) {
        return shellFeedsApi.getRotationalPreviewIds();
    }
    return "";
}
/**
 * Try to get current cache feeds service activity ID, return empty when cache is invalid.
 */
export async function getCurrentFeedsServiceActivityID() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 1, 1);
    if (shellFeedsApi) {
        return shellFeedsApi.getCurrentFeedsServiceActivityID();
    }
    return "";
}
/**
 * Try to get current default preview content that is being shown in the taskbar, return empty when taskbar is rotational.
 */
export async function getCurrentDefaultPreviewContent() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 1, 1);
    if (shellFeedsApi) {
        return shellFeedsApi.getCurrentDefaultPreviewContent();
    }
    return "";
}
/**
 * Try to get current preview being shown in taskbar ids. Returns empty when Widgets flyout is not visible.
 */
export async function getCurrentPreviewInTaskbar() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 5, 5);
    if (shellFeedsApi) {
        return shellFeedsApi.getCurrentPreviewInTaskbar();
    }
    return "";
}
/**
 * Gets taskbar Setting changed event info as json
 */
export async function getTaskbarSettingChangedInfo() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 2, 2);
    if (shellFeedsApi) {
        return shellFeedsApi.getTaskbarSettingChangedInfo();
    }
    return "";
}
export async function isCurrentFeedsStaticFallback() {
    const shellFeedsApi = await tryGetHostApi("Feeds", 3, 3);
    if (shellFeedsApi) {
        return shellFeedsApi.isCurrentFeedsStaticFallback;
    }
    return false;
}
export async function refreshFeedsContentAsync(verb, data, callback) {
    const shellFeedsApi = await tryGetHostApi("Feeds", 4, 4);
    if (shellFeedsApi && typeof shellFeedsApi.refreshFeedsContentAsync === "function") {
        return await shellFeedsApi.refreshFeedsContentAsync(verb, data, callback);
    }
    return await callback(RefreshContentTaskStatus.Failed);
}
